export default __webpack_public_path__ + "assets/c93ce8c46a77c5b3d282e1eacc61220d.jpg";